module.exports = __webpack_public_path__ + "fonts/text-semibold.4d2e814b.woff2";